export const clientPathPrefix = "/cp";
